(function () {
	'use strict';
	/*	UI.FORMS ------------------------------------------------------------------------------
		handling for Date fields in forms, or as standalone forms
	*/
	var Forms = (function(){

		var $datePickers = $('.date input[type=text]'),

		init = function () {

			// set up datepicker if existent
			if( $datePickers.length ) {

				/*
					DateFormat has to be consistent with the one set in editor templates.
					If you change DateFormat in this file, make sure to change it in editor templates as well.
				*/
				var dateFormat = 'YYYY-MM-DD';

				/*jshint ignore:start */
				$datePickers.each(function () {
					var $datePicker = $(this);

					var options = {
						field: $datePicker[0],
						format: dateFormat,
						firstDay: 0
					};

					var minDate = $datePicker.attr('data-pp-mindate');
					var maxDate = $datePicker.attr('data-pp-maxdate');
					var afterDate = $datePicker.attr('data-pp-afterdate');

					if (minDate) {
						var minDateArr = minDate.split('-');
						options.minDate = new Date(minDateArr[0], minDateArr[1]-1, minDateArr[2]);
					}

					if (maxDate) {
						var maxDateArr = maxDate.split('-');
						options.maxDate = new Date(maxDateArr[0], maxDateArr[1]-1, maxDateArr[2]);
					}

					if (afterDate) {
						var $other = $('#' + afterDate);
						if ($other && $other.length > 0) {
							var otherDate = moment($other.val());
							if (otherDate) {
								options.minDate = otherDate.add(1, 'day').toDate();
							}

							$other.on('change', function() {
								var thisPicker;

								var otherDate = moment($other.val());
								if (otherDate.isValid()) {
									thisPicker = $datePicker.data('picker');
								}

								if (thisPicker) {
									var minDate = otherDate.add(1, 'day');
									thisPicker.setMinDate(minDate.toDate());
									var thisDate = moment($datePicker.val());
									if (!thisDate.isValid() || thisDate.isBefore(minDate)) {
										thisPicker.setDate();
										thisPicker.gotoDate(minDate.toDate());
										$datePicker.val('').trigger("change");
									}
								}
							});
						}
					}

					$datePicker.data('picker', new Pikaday(options));
					return $datePicker;
				});
				/*jshint ignore:end */
			}

		};

		return { init: init };

	}());
	var StandaloneForms = (function () {

		var $standalonePickers = $('.standalone-date input[type=text]');
		var initStandalone = function () {

			if ($standalonePickers.length) {
				var dateFormat = 'YYYY-MM-DD'; //Not really a fan of this, but for consitency's sake

				$standalonePickers.each(function () {
					var picker = $(this)[0];
					new Pikaday({
						field: picker,
						format: dateFormat,
						firstDay: 0,
						onSelect: function () {
							$(picker).closest('form').submit();
						}
					});
				});
			}
		};

		return { init: initStandalone };

	}());

	$(document).ready(function(){
		Forms.init();
		StandaloneForms.init();
	});
}());
